<!--component for adding new phrases. used on phrase page-->
<template>
  <div class="mx-auto center py1">
    <div class="flex">
      <div class="col-3">
        <div class="flex input-addon mr3">
          <input v-model="hashtag" type="text" class="col-12 order-1" :placeholder="'fraasi' + (!profile.admin ? '' : ' tai ##jaettu-fraasi')">
          <div class="flex-none semibold">#</div>
        </div>
        <div class="flex flex-none error" v-if="hasError">Sana on jo käytössä</div>
      </div>
      <div class="flex col-9">
        <textarea-autosize
          class="phrase-input"
          ref="phraseInputTextArea"
          :min-height="37"
          :max-height="175"
          rows="1"
          placeholder="Korvaava teksti"
          v-model="phrase"
        />
        <v-button variant="icon" @click="savePhrase" class="flex-none ml1">
          <svg width="23" height="23" viewBox="0 0 23 23" xmlns="http://www.w3.org/2000/svg">
            <g stroke="#00A1D4" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
              <path d="M22.5 11.5c0 6.074-4.925 11-11 11s-11-4.926-11-11c0-6.076 4.925-11 11-11s11 4.924 11 11zM11.5 5.5v12M17.5 11.5h-12"/>
            </g>
          </svg>
        </v-button>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from "vuex"
import Button from '@/components/Button.vue'
import router from '@/router';
import TextareaAutosize from '@/components/TextareaAutosize.vue'

export default {
  name: 'Phrases',
  data () {
    return {
      hasError: false,
      hashtag: '',
      phrase: '',
    };
  },
  components: { TextareaAutosize, 'v-button': Button },
  computed: {
    ...mapGetters({
        profile: 'profile',
        phrases: 'allPhrases',
    }),
  },
  mounted: function() {
  },
  methods: {
    savePhrase() {
      if (!this.hashtag.length || !this.phrase.length) {
        return;
      }

      const hashtag = (this.profile.admin && this.hashtag.startsWith('#') ? '#' : '') + this.hashtag.replace(/^#+/, '');

      if (this.phrases.some(x => x.hashtag === hashtag)) {
        this.hasError = true;
        return;
      }

      const newPhrase = {
        hashtag: this.hashtag,
        phrase: this.phrase
      }
      this.hasError = false;
      this.hashtag = '';
      this.phrase = '';
      this.$store.dispatch('savePhrase', newPhrase);
    },
    goBack() {
      router.push('/new');
    },
  }
}

</script>

<style scoped>
  .input-addon > div {
    padding: var(--space-1);
    padding-right: 0;
    color: var(--dark-blue);
    font-size: var(--h5);
    border: 1px solid var(--gray-3);
    border-right: 0;
    margin-right: -1px;
    z-index: 1;
    background-color: #fff;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .input-addon > input {
    padding-left: 0;
  }

  .input-addon > input:focus ~ div {
    border-color: var(--dark-blue)
  }

  .phrase-input {
    flex: auto;
    margin: 0;
    padding: .50rem;
    font-size: var(--h5);
    resize: none;
    background-color: transparent;
    width: 100%;
  }

  .error {
    color: red;
    font-size: var(--h5);
    font-weight: bold;
  }
</style>
